
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Device } from '~/interfaces/device.interface';
import { ConfigModule } from '~/store/modules/config';

@Component
export default class Offset extends Vue {
    @Prop() device!: Device;

    get host() {
        return ConfigModule.environment === 'integration' ? 'https://kibana2.inte.netatmo.com' : 'https://kibana2.netatmo.com:1443';
    }

    get jsonIndex() {
        return ConfigModule.environment === 'integration' ? 'cee5a320-e69e-11ec-88ca-1772abb5e2a7' : '919ced80-01e6-11ed-bfac-f9c3927ab5ca';
    }

    get netcomIndex() {
        return ConfigModule.environment === 'integration' ? 'd301f410-e69c-11ec-88ca-1772abb5e2a7' : '56cefa50-01ef-11ed-bfac-f9c3927ab5ca';
    }

    get outdatedKibanaLink() {
        return `${this.host}/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),`
            + 'time:(from:now-30m,to:now))&_a=(columns:!(),filters:!((\'$state\':(store:appState),'
            + `meta:(alias:!n,disabled:!f,index:'${this.jsonIndex}',key:log.channel,`
            + 'negate:!f,params:(query:netcom-event-consumer),type:phrase),query:(match_phrase:'
            + '(log.channel:netcom-event-consumer))),(\'$state\':(store:appState),meta:(alias:!n,'
            + `disabled:!f,index:'${this.jsonIndex}',key:context.device_id,`
            + `negate:!f,params:(query:'${this.device.id}'),type:phrase),query:(match_phrase:`
            + `(context.device_id:'${this.device.id}')))),index:'${this.jsonIndex}',`
            + 'interval:auto,query:(language:lucene,query:\'\'),sort:!(!(\'@timestamp\',desc)))';
    }

    get kibanaLink() {
        return `${this.host}/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-90d,to:now))&_a=(columns:!(context.battery_voltage_mv,context.cycle_cnt,context.block_cnt,context.mech_anomaly_cnt,context.motor_calibration_cnt,context.failed_motor_calibration_cnt,context.reboot_cnt),dataSource:(dataViewId:c9c7347c-f717-4638-ad45-7063e3b9c4c8,type:dataView),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'${this.jsonIndex}',key:log.channel,negate:!f,params:(query:netcom-event-consumer),type:phrase),query:(match_phrase:(log.channel:netcom-event-consumer))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'${this.jsonIndex}',key:context.device_id,negate:!f,params:(query:'${this.device.id}'),type:phrase),query:(match_phrase:(context.device_id:'${this.device.id}')))),interval:auto,query:(language:lucene,query:''),sort:!(!('@timestamp',desc)))`;

    }

    get additionalKibanaLink() {
        const network = this.device.network;
        if (network?.vpn || (!network?.server_node && !network?.netcom_transport)) { return ''; }
        return `${this.host}/app/discover#/?_g=(filters:!(),`
            + 'refreshInterval:(pause:!t,value:0),time:(from:now-30m,to:now))&_a=(columns:!(),'
            + 'filters:!((\'$state\':(store:appState),meta:(alias:!n,disabled:!f,'
            + `index:'${this.netcomIndex}',key:client.mac,negate:!f,`
            + `params:(query:'${this.device.id}'),type:phrase),query:(match_phrase:(client.mac:'${this.device.id}')))),`
            + `index:'${this.netcomIndex}',interval:auto,query:(language:lucene,query:''),`
            + 'sort:!(!(\'@timestamp\',desc)))';
    }
}
